export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 8_04.adfc75b5.jpg";